import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import CSS from 'csstype';

export const useAlert = (title, icon = null) => {
    const MySwal = withReactContent(Swal)

    const header = (
        <div className='full-w flex flex-col items-center'>
            <img src="/assets/img/icons/casco-icon.svg" alt="Icono" width={'36.25px'} />
            <p className='mt-4' style={titleStyle}>{title}</p>
        </div>
    )

    let fire = function (template = <p></p>) {
        MySwal.fire({
            title: header,
            html: template,
            showConfirmButton: false,
            didOpen: () => {
                // `MySwal` is a subclass of `Swal`
                //   with all the same instance & static methods
                //MySwal.clickConfirm()
            }
        })
    }

    let close = function () {
        MySwal.clickConfirm();
    }

    return { fire, close };
}

const titleStyle: CSS.Properties = {
    color: '#012349',
    fontSize: '16px',
    fontWeight: '600'
}